import { css } from 'emotion'

export const UpdateTaskSizesFormStyles = css`
  .TextInputField {
    margin-top: 32px;
  }
`
